export default __webpack_public_path__ + "static/media/RedingtonFooter.f2001d3f.png";